import { Box, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import TestingFeedbackModal from "../components/Modals/TestingFeedbackModal";
import RecipeList from "../components/Recipes/RecipeList";
import SearchRecipe from "../components/Recipes/SearchRecipe";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { flexCenter, secondaryButton } from "../styles/commonStyles";
import AppInfoSection from "../components/Recipes/AppInfoSection";

const RecipesPage = () => {
  useDocumentTitle("recipes");
  const { t } = useTranslation();

  return (
    <>
      <AppInfoSection />
      <Box sx={flexCenter}>
        <Box sx={{ flexGrow: 1 }}>
          <SearchRecipe />
        </Box>
        <Box component={Link} to="/recipe/add" sx={{ textDecoration: "none" }}>
          <Button sx={secondaryButton}>{t("addNewRecipe")}</Button>
        </Box>
      </Box>
      <RecipeList />
      <TestingFeedbackModal />
    </>
  );
};

export default RecipesPage;
